import { useBooleanState, useNavigator } from 'annotation-tools/utils';
import React, { FC, memo, useCallback } from 'react';
import { useLoggedIn, useUserDetail } from '../../global-state/auth-state';
import { routes } from '../../routing/routes';
import { AppBarView } from './app-bar-view';

export const AppBar: FC<{}> = memo(() => {
  const loggedIn = useLoggedIn();
  const { name } = useUserDetail();

  const navigator = useNavigator();

  const [dialogIsOpen, open, close] = useBooleanState(false);

  const homeIconOnClick = useCallback(() => {
    navigator(routes.home);
  }, [navigator]);

  const onKoumutenListClick = useCallback(() => {
    navigator(routes.koumutenList);
  }, [navigator]);

  const userListOnClick = useCallback(() => {
    navigator(routes.userList);
  }, [navigator]);

  const csvListOnClick = useCallback(() => {
    navigator(routes.csvList);
  }, [navigator]);

  return (
    <AppBarView
      username={name}
      loggedIn={loggedIn}
      logoutOnClick={open}
      dialogOpen={dialogIsOpen}
      onClose={close}
      homeIconOnClick={homeIconOnClick}
      onKoumutenListClick={onKoumutenListClick}
      userListOnClick={userListOnClick}
      csvListOnClick={csvListOnClick}
    />
  );
});

AppBar.displayName = 'AppBar';
